import { AnalyzerModuleReturn } from '../../../types';

export const getUniqueModuleTypes = (
  modules: AnalyzerModuleReturn[] | undefined
): string[] => {
  if (!modules) return [];
  const uniqueModules: string[] = [];
  for (const module of modules) {
    for (const type of module.types) {
      if (!uniqueModules.some((existingModule) => type === existingModule)) {
        uniqueModules.push(type);
      }
    }
  }
  return uniqueModules;
};

export const getConnectionColor = (item: any | undefined) => {
  if (!item) return 'blue';
  if (!item.enabled) return '#FF505F';
  else return '#21CC66';
};
